import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "./Context/Theme";
import { AuthProvider } from "./Context/Auth";
import {
  ReloadProvider,
  RestaurantDataProvider,
} from "./Context/RestaurantData";
import Amplify from "@aws-amplify/core";
import awsconfig from "./aws-exports";
import { RouteProvider } from "./Context/RouteContext";
import * as Sentry from "@sentry/react";

import { Integrations } from "@sentry/tracing";
import { ApiProvider } from "./Context/ApiKey";
import { AxiosProvider, AxiosContext } from "./Context/axiosContext";
import { SnackBarProvider } from "./Context/SnackBar";
import { Provider } from "react-redux";
import store from "./store/index";
console.log("sentry dsn", process.env.REACT_APP_SENTRY_DSN);
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
Amplify.configure(awsconfig);

ReactDOM.render(
  <Router>
    {" "}
    <Provider store={store}>
    <AuthProvider>
      <RestaurantDataProvider>
        <ThemeProvider>
          <RouteProvider>
            <ApiProvider>
              <ReloadProvider>
                <SnackBarProvider>
                  <AxiosProvider>
                    <App />
                  </AxiosProvider>
                </SnackBarProvider>
              </ReloadProvider>
            </ApiProvider>
          </RouteProvider>
        </ThemeProvider>
      </RestaurantDataProvider>
    </AuthProvider>
    </Provider>
  </Router>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
